import { render, staticRenderFns } from "./datasource-boxes.vue?vue&type=template&id=1a4d5131&scoped=true"
import script from "./datasource-boxes.vue?vue&type=script&lang=js"
export * from "./datasource-boxes.vue?vue&type=script&lang=js"
import style0 from "./datasource-boxes.vue?vue&type=style&index=0&id=1a4d5131&prod&lang=scss&scoped=true"
import style1 from "./datasource-boxes.vue?vue&type=style&index=1&id=1a4d5131&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d5131",
  null
  
)

export default component.exports